import { useState } from "react";

const CustomHeader = (props) => {
  const { displayName, setSort, column } = props;
  const [activeSort, setActiveSort] = useState("asc");

  // Handle sorting when clicking anywhere on the header
  const handleHeaderClick = () => {
    const currentSort = column.getSort();
    const nextSort = currentSort === "asc" ? "desc" : "asc"; // Toggle between asc and desc
    setSort(nextSort);
    setActiveSort(currentSort);
  };

  return (
    <div
      style={{
        cursor: "pointer",
        fontSize: "13px",
        justifyContent: "space-between",
        width: "100%",
        fontWeight: "700",
        textTransform: "uppercase",
        // color: "#2d4e6a",
        color: "#fff",
        letterSpacing: "0.5px",
        textAlign: "center",
      }}
      className="custom-header w-100 h-100 d-flex align-items-center"
      onClick={handleHeaderClick}
    >
      <span>{displayName}</span>
      <span
        style={{ color: "white", marginLeft: ".5rem" }}
        className={
          activeSort === "asc" ? "ag-icon ag-icon-desc" : "ag-icon ag-icon-asc"
        }
      ></span>
    </div>
  );
};

export default CustomHeader;
